module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct3"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('b', [_vm._v("Also in the Sean Coleman Thriller series from John A. Daly")])])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('p', {
    staticClass: "txc"
  }, [_c('i', [_vm._v("From a Dead Sleep")])]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_c('i', [_vm._v("Blood Trade")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a677eeae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter01.vue
// module id = 63
// module chunks = 0